export default __webpack_public_path__ + "static/precog-black-wordmark-a5bbae164e69b731e395976cbf9345b3.png";